import { Pipe, PipeTransform } from '@angular/core';
import { toArray, isArray, objectContains, isUndefined } from '../utils/utils';

@Pipe({
  name: 'removeWith'
})
export class RemoveWithPipe implements PipeTransform {
  transform(collection: any, object?: any): any {
    if (!isArray(collection)) {
      collection = toArray(collection);
    }

    if (!isArray(collection) || isUndefined(object)) {
      return collection;
    }

    return collection.filter((e: any) => !objectContains(object, e));
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./node_modules/ng-pipes/src/collection/remove-with.pipe.ts